module.exports = {
  "country": "FR",
  "artist": "Marie Myriam",
  "song": "L'oiseau et l'enfant",
  "year": "1977",
  "place": "1",
  "spotify": "7Hy0CZtFcREucLDXB5jp6m"
};